import { connect } from 'react-redux';
import type { WithRouterProps } from 'react-router';
import { Dispatch } from 'redux';
import { changeLanguage } from '../../actions/languages';
import { getDefaultLocale, getLocales } from '../../selectors/app';
import { CheckoutState } from '../../state';
import { getCheckoutStepFromPath } from '../../utils/analytics';
import type { LanguageAndBrandProps } from './LanguageAndBrand';

type ConnectedPropsFromState = Pick<
    LanguageAndBrandProps,
    'locales' | 'defaultLocale'
>;

const mapStateToProps = (state: CheckoutState): ConnectedPropsFromState => ({
    locales: getLocales(state),
    defaultLocale: getDefaultLocale(state),
});

type ConnectedPropsFromDispatch = Pick<
    LanguageAndBrandProps,
    'onSelectLanguage'
>;

const mapDispatchToProps = (
    dispatch: Dispatch<CheckoutState>,
    { location }: WithRouterProps,
): ConnectedPropsFromDispatch => ({
    onSelectLanguage: (locale: string) =>
        dispatch(
            changeLanguage(locale, getCheckoutStepFromPath(location.pathname)),
        ),
});

export type ConnectedProps = ConnectedPropsFromState &
    ConnectedPropsFromDispatch;

export default connect(mapStateToProps, mapDispatchToProps);
